module.exports = __webpack_public_path__ + "assets/open_question.476ef3d9.svg";